import React from "react";
import { useUser, useUserStatus } from "../state";
import { api } from "../api";
import { XMarkIcon } from "@heroicons/react/24/solid";

export const IMPERSONATION_BANNER_HEIGHT = "h-10"; // 40px
export const IMPERSONATION_BANNER_TOP_OFFSET = "top-10"; // 40px
export const IMPERSONATION_BANNER_PADDING = "pt-10"; // 40px

export const useIsImpersonating = (): boolean => {
  const userState = useUser();
  if (userState.type !== "logged-in") return false;
  return !!(userState.user as any)._isAssuming;
};

export const ImpersonationBanner = (): JSX.Element | null => {
  const userState = useUser();
  const { refreshUser } = useUserStatus();

  if (userState.type !== "logged-in") {
    return null;
  }

  const user = userState.user as any;

  if (!user._isAssuming) {
    return null;
  }

  const handleStopAssuming = async () => {
    await api.post("/api/support/stop-assume", {});
    await refreshUser();
  };

  return (
    <>
      {/* Spacer to push content down */}
      <div className={IMPERSONATION_BANNER_HEIGHT} />
      {/* Fixed banner */}
      <div className={`fixed inset-x-0 top-0 z-[100] flex ${IMPERSONATION_BANNER_HEIGHT} items-center justify-center gap-4 bg-amber-500 px-4 text-sm font-medium text-black shadow-lg`}>
        <span>
          Viewing as <strong>{user._assumingAs}</strong>
        </span>
        <button
          onClick={handleStopAssuming}
          className="flex items-center gap-1 rounded bg-black/20 px-3 py-1 transition hover:bg-black/30"
        >
          <XMarkIcon className="h-4 w-4" />
          Stop
        </button>
      </div>
    </>
  );
};
